import { v4 as uuidv4 } from "uuid";
import { Dispatch } from "redux";
import { datadogLogs } from '@datadog/browser-logs';
import { addAppAlert } from "@redux/actions/app-alerts-actions";
import { IDWAppAlertTypes } from "@enums/idw-app-alert-types";
import { resources } from "@constants/hardcoded-strings";
import { QueryParameter } from "@idw-types/common";
import { ErrorlogDetail } from "@idw-types/error-log-detail";


export const logAndDisplayErrorModal = (
    dispatch: Dispatch,
    error: any,
    title: string,
    message: string,
    detailedMessage?: string,
    queryParameters?: Array<QueryParameter>,
    body?: { [key: string]: any }
) => {
    
    const logDetails: ErrorlogDetail = {
        error
    };

    const errorId = uuidv4();
    const errorMessage = `An error occurred and the error modal was display to the user with title: ${title}, message: ${message}, errorId: ${errorId}. Error: ${error}`;
    console.error(errorMessage);

    let modalTitle = title;
    let modalMessage = message;
    if (error?.code === 403) {
        modalTitle = resources.requests.accessDenied.error.title;
        modalMessage = resources.requests.accessDenied.error.message;
    }

    if(queryParameters) {
        logDetails.queryParameters = queryParameters;
    }

    if(body) {
        logDetails.body = body;
    }

    datadogLogs.logger.error(errorMessage, logDetails);

    dispatch(addAppAlert({
        type: IDWAppAlertTypes.ERROR,
        title: modalTitle,
        message: modalMessage,
        detailedMessage: detailedMessage,
        id: errorId
    }));
};

export const displaySuccessModal = (dispatch: Dispatch, title: string, message: string) => {
    const successId = uuidv4();
    dispatch(addAppAlert({
        type: IDWAppAlertTypes.SUCCESS,
        title: title,
        message: message,
        id: successId
    }));
};